import * as api from "./apiUtils";
const baseUrl = `${api.apiUrl}authentication\\`;

export async function authenticate(authData) {
    return api.postAsync(`${baseUrl}authenticate`, authData);
}

export async function register(authData) {
    return api.postAsync(`${baseUrl}register`, authData);
}

export async function getUserData(userId) {
    return api.getAsync(`${baseUrl}getUserData`, userId);
}